export const ALL = 'all';
export const FAVORITE = 'favorites';
export const PLATFORM = 'platform';
export const MY = 'my';
